import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const CloseIcon: React.FC<Props> = ({ color }) => {
	const stroke = getColor(color);
	return (
		<svg
			role="img"
			aria-label="Close"
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M25 1L1 25" stroke={stroke} strokeLinecap="round" />
			<path d="M1 1L25 25" stroke={stroke} strokeLinecap="round" />
		</svg>
	);
};
